function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 3.8637,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  x: 1.543,
  y: 1.59,
  width: 94.133,
  height: 94.133
}), /*#__PURE__*/React.createElement("polygon", {
  points: "70.824 26.223 48.61 20.945 72.363 12.807"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "26.397 26.223 48.61 20.945 24.857 12.807"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "95.676 1.59 72.363 12.807 24.857 12.807 1.543 1.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "26.176 26.443 20.898 48.657 12.76 24.903"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "26.176 70.87 20.898 48.657 12.76 72.41"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "1.543 1.59 12.76 24.903 12.76 72.41 1.543 95.723"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "26.397 71.09 48.61 76.369 24.857 84.506"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "70.824 71.09 48.61 76.369 72.363 84.506"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "1.543 95.723 24.857 84.506 72.363 84.506 95.676 95.723"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "71.043 70.87 76.322 48.657 84.459 72.41"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "71.043 26.443 76.322 48.657 84.459 24.903"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "95.676 95.723 84.459 72.41 84.459 24.903 95.676 1.59"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(109.43 -.0062554)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 3.8637,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  x: 1.543,
  y: 1.59,
  width: 94.133,
  height: 94.133
}), /*#__PURE__*/React.createElement("polygon", {
  points: "72.363 12.807 70.824 26.223 48.61 20.945"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "24.857 12.807 26.397 26.223 48.61 20.945"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "95.676 1.59 72.363 12.807 24.857 12.807 1.543 1.59"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "12.76 24.903 26.176 26.443 20.898 48.657"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "12.76 72.41 26.176 70.87 20.898 48.657"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "1.543 1.59 12.76 24.903 12.76 72.41 1.543 95.723"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "24.857 84.506 26.397 71.09 48.61 76.369"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "72.363 84.506 70.824 71.09 48.61 76.369"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "1.543 95.723 24.857 84.506 72.363 84.506 95.676 95.723"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "84.459 72.41 71.043 70.87 76.322 48.657"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "84.459 24.903 71.043 26.443 76.322 48.657"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "95.676 95.723 84.459 72.41 84.459 24.903 95.676 1.59"
}));

const SvgPrincessPair = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Foreground",
  width: 206,
  height: 97,
  enableBackground: "new 0 0 97 97",
  viewBox: "0 0 206 97",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPrincessPair, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/princess-pair.74fac38d.svg";
export { ForwardRef as ReactComponent };